import {
    GET_MENU_SETTING_LIST_PROGRESS, GET_MENU_SETTING_LIST_SUCCESS, GET_MENU_SETTING_LIST_FAILURE,
    ADD_MENU_SETTING_PROGRESS, ADD_MENU_SETTING_SUCCESS, ADD_MENU_SETTING_FAILURE,
    EDIT_DELETE_MENU_SETTING_PROGRESS, EDIT_DELETE_MENU_SETTING_SUCCESS, EDIT_DELETE_MENU_SETTING_FAILURE,

    RESET_MESSAGE,

} from '../../types/actionTypes';

const initialState = {
    menuSetting: [],
    loginUser: null,
    error: false,
    loading: false,
    message: null
}

const menu_setting_reducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_MENU_SETTING_LIST_SUCCESS:
            return { ...state, menuSetting: action.menuSetting, loading: false };
        case GET_MENU_SETTING_LIST_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_MENU_SETTING_LIST_PROGRESS:
            return { ...state, loading: true, error: false };
        case ADD_MENU_SETTING_PROGRESS:
            return { ...state, loading: true };
        case ADD_MENU_SETTING_SUCCESS:
            return { ...state, menuSetting: [...state.menuSetting, action.payload], loading: false, error: false, message: action.payload.message };
        case ADD_MENU_SETTING_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };
        case EDIT_DELETE_MENU_SETTING_PROGRESS:
            return { ...state, loading: true };
        case EDIT_DELETE_MENU_SETTING_SUCCESS:
            return {
                ...state,
                menuSetting: state.menuSetting.map((menuSetting) =>
                    menuSetting.id === action.payload.id ? action.payload : menuSetting
                ),
                message: action.payload.message
            };
        case EDIT_DELETE_MENU_SETTING_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message};

        case RESET_MESSAGE:
            return { ...state, message: null }; // Reset the edit message

        default:
            return state
    }
}

export default menu_setting_reducer;